import React from 'react';
import './WHMCS.css';

const WHMCSPaymentGateway = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <>
      <div className="seo-header">
        <h1>ماژول درگاه پرداخت WHMCS | اتصال درگاه‌های ایرانی و بین‌المللی | افراسل</h1>
        <p>اتصال درگاه‌های پرداخت ایرانی و بین‌المللی به WHMCS با امنیت بالا و نصب حرفه‌ای.</p>
        <meta name="description" content="اتصال درگاه‌های پرداخت ایرانی و بین‌المللی به WHMCS با امنیت بالا." />
      </div>

      <section className="whmcs-hero">
        <div className="whmcs-hero-bg"></div>
        <div className="wrap">
          <div className="whmcs-hero-content">
            <div className="whmcs-badge">
              <span className="pulse-dot"></span>
              💳 درگاه پرداخت WHMCS
            </div>
            <h1 className="whmcs-hero-title">
              درگاه پرداخت <em>WHMCS</em>
            </h1>
            <p className="whmcs-hero-desc">
              اتصال درگاه‌های پرداخت به WHMCS یکی از مهم‌ترین بخش‌های راه‌اندازی کسب‌وکار آنلاین است. ما در افراسل پشتیبانی کامل از درگاه‌های پرداخت ایرانی (زرین‌پال، پارسیان، ملت، سامان، پاسارگاد) و بین‌المللی (PayPal، Stripe، 2Checkout) را ارائه می‌دهیم. نصب و کانفیگ حرفه‌ای با امنیت بالا.
            </p>
            <div className="whmcs-hero-stats">
              <div className="stat-item">
                <span className="stat-number">امن</span>
                <span className="stat-label">اتصال مطمئن</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۱۰۰+</span>
                <span className="stat-label">پروژه موفق</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۲۴/۷</span>
                <span className="stat-label">پشتیبانی</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="whmcs-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              درگاه پرداخت <em>WHMCS</em> را با افراسل تجربه کنید
            </h2>
            <p className="cta-desc">
              با اتصال درگاه‌های پرداخت به WHMCS، فروش خود را افزایش دهید.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>مشاوره رایگان</button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>درخواست خدمات</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WHMCSPaymentGateway;
